// removed by extract-text-webpack-plugin
module.exports = {"Testimonial":"_3UY5dxKi","Row":"eQD0XTg9","FlexRow":"_1Fx00n-r","TitleLine":"_2FBwCDOP","Name":"Xa_YGeKr","Rating":"_1v5B4qW0","Date":"GWtqkON2","Star":"_19aaTwSz","FilledStar":"k4JkeNUt","SourceIcon":"_2L1x48sg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cards/testimonial/testimonial-component.styles.scss
// module id = 234
// module chunks = 0